// interfaces
import { PaymentGroup, PaymentGroupMeta, PaymentGroupActions, PaymentMethod, PaymentMethodMeta } from "./Payment";
import { SwiggyMoneyInfoHalfCardModel, SwiggyMoneyInfoActions, AddSwiggyMoneyActions } from "./SwiggyMoney";

export interface SwiggyInstrumentsPaymentGroup
    extends PaymentGroup<PaymentGroupMeta, SwiggyInstrumentsPaymentMethodData> {
    paymentActions: SwiggyInstrumentsPaymentGroupActions;
}

export interface SwiggyInstrumentsMeta extends PaymentMethodMeta {
    infoMessage?: string;
    learnMoreHalfCard?: SwiggyMoneyInfoHalfCardModel;
    monthlyDebitLimitExceeded?: boolean;
}

export interface SwiggyInstrumentsPaymentMethodData extends PaymentMethod<PaymentMethodMeta> {
    eligibleBalance: string;
    balance: string;
    showAddMoneyCta: boolean;
    addMoneyCtaMessage?: string;
    showLearnMoreHalfCard: boolean;
    meta: SwiggyInstrumentsMeta;
}

export interface SwiggyInstrumentsData {
    eligibleBalance: string;
    balance: string;
    additionalBalanceRequired: string;
    isBalanceSufficient: boolean;
}

export type SwiggyInstrumentsPaymentGroupActions = PaymentGroupActions<SwiggyInstrumentsPaymentMethodData> &
    SwiggyInstrumentsSpecificActions;
export interface SwiggyInstrumentsSpecificActions extends AddSwiggyMoneyActions {
    getSwiggyInstrumentsData: (methodData: SwiggyInstrumentsPaymentMethodData) => SwiggyInstrumentsData;
    swiggyMoneyInfoActions: SwiggyMoneyInfoActions;
}

export interface SuggestedAmounts {
    amount: number;
    preSelected: boolean;
    mostPopular?: boolean;
}

interface LimitValidationMeta {
    limit: number;
    message: string;
    showLearnMoreHalfCard: boolean;
}

export interface ValidationInfo {
    creditValidation: LimitValidationMeta;
    debitValidation: LimitValidationMeta;
    cashbackValidation: LimitValidationMeta;
    minErrorValidation: LimitValidationMeta;
}

export interface AddMoneyEligibility {
    availableCreditLimit: number;
    transactionAllowed: boolean;
    transactionEligibilityReason: string;
    suggestedAmounts: SuggestedAmounts[];
    addMoneyNotes: string[];
    validationInfo: ValidationInfo;
    learnMoreHalfCard: SwiggyMoneyInfoHalfCardModel;
}

export interface AddSwiggyMoneyProps {
    selectionAmount: number;
    offers: string[];
    eligibilityDetails: AddMoneyEligibility;
    updateSelectedAmount: (amount: number) => void;
    onAddMoney: () => void;
    balance: number;
    clickPredefinedAmount: (amount: number) => void;
    swiggyMoneyInfoActions: SwiggyMoneyInfoActions;
    isSwMoneyBusinessLine?: boolean;
    redirectToVoucher?: VoidFunction;
}

export interface InfoHeaderProps {
    balance: number;
    eligibilityDetails: AddMoneyEligibility;
}

export interface OffersProps {
    offers: string[];
}

export interface AmountWarnMessage {
    minErrorMessage: string;
    maxErrorMessage: string;
}

export interface AmountOption {
    amount: number;
    preSelected: boolean;
    mostPopular?: boolean;
}

export interface OnAmountBoxSelectionParams {
    amount: number;
    selected: boolean;
}
export interface AmountSelectionWidgetProps {
    amountOptions: AmountOption[];
    amount?: number;
    reflectChangedAmountImmediately?: boolean;
    onUpdateAmount: (amount: number) => void;
    inputScrollIntoView?: boolean | number;
    clickPredefinedAmount: (amount: number) => void;
    inputFieldPlaceHolder: string;
    swiggyMoneyInfoHalfCard?: SwiggyMoneyInfoHalfCardModel;
    swiggyMoneyInfoActions: SwiggyMoneyInfoActions;
    violationInfo: ViolationState;
}

export enum ViolationType {
    NONE,
    WARNING,
    ERROR,
}

export interface ViolationState {
    type: ViolationType;
    message: string;
    showSwiggyMoneyInfoHalfCard: boolean;
}
